import { Add } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import React from 'react';

import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesSettingsHeader/CapsulesSettingsHeader.module.scss';

type CapsulesSettingsHeaderProps = {
  onRegisterCapsule?: () => void;
  registerDisabled?: boolean;
  showRegisterAction?: boolean;
};

type Props = React.FC<CapsulesSettingsHeaderProps>;

export const CapsulesSettingsHeader: Props = (props) => {
  const { onRegisterCapsule, registerDisabled, showRegisterAction = true } = props;

  return (
    <div className={styles.headerContainer}>
      <div className={styles.header}>
        <div>
          <Typography variant="h3" className={styles.title}>
            Capsules
          </Typography>
          <Typography variant="body2">
            Self-hosted runtimes that run data flows in your own infrastructure.
          </Typography>
        </div>

        {showRegisterAction ? (
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={onRegisterCapsule}
            disabled={!onRegisterCapsule || registerDisabled}
            data-testid="register-capsule-btn"
          >
            Register capsule
          </Button>
        ) : null}
      </div>
    </div>
  );
};

CapsulesSettingsHeader.displayName = 'CapsulesSettingsHeader';
